import React from 'react';
import { Box, Flex, Text, Icon } from '@chakra-ui/react';
import { FiInfo } from 'react-icons/fi';
import { getPaymentInvoicingInfo } from 'api/administrador/refunds';

export default function PaymentInvoicingNotice({ payment, mb = 4 }) {
  if (!payment) return null;

  const info = getPaymentInvoicingInfo(payment);

  return (
    <Box
      mb={mb}
      p={3}
      borderRadius="md"
      border="1px solid"
      borderColor={info.isFactured ? '#FCD34D' : '#BEE3F8'}
      bg={info.isFactured ? '#FFFBEB' : '#EBF8FF'}
    >
      <Flex align="flex-start" gap={2}>
        <Icon as={FiInfo} color={info.isFactured ? '#B45309' : '#2B6CB0'} mt={0.5} flexShrink={0} />
        <Box>
          <Text fontSize="sm" fontWeight="bold" color={info.isFactured ? '#92400E' : '#2C5282'}>
            {info.noticeTitle} · {info.creditNoteLabel}
          </Text>
          <Text fontSize="sm" color={info.isFactured ? '#92400E' : '#2C5282'} mt={1} lineHeight="tall">
            {info.noticeMessage}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}
